import requestClient from '../lib/requestClient';
import { handleApiErrors } from '../lib/utils';

/**
 * makes a login request to the api
 * @function
 * @param {string} email - email
 * @param {string} password - password
 * @return {void}
 */
export const login = async (email, password) => {
	return await requestClient()
		.post('/auth/login', {
			email,
			password,
		})
		.catch((error) => {
			return handleApiErrors(error);
		});
};

/**
 * makes a password reset request to the api
 * @function
 * @param {string} email - email
 * @return {void}
 */
export const resetPassword = async (email) => {
	return await requestClient()
		.post('/auth/passwordreset', {
			email,
		})
		.catch((error) => {
			return handleApiErrors(error);
		});
};

/**
 * makes a set new password request to the api
 * @function
 * @param {string} password - password
 * @param {string} token - token
 * @return {void}
 */
export const setNewPassword = async (password, token) => {
	return await requestClient()
		.patch(
			'/auth/passwordresetverify',
			{
				password,
			},
			{
				headers: {
					Authorization: token,
				},
			}
		)
		.catch((error) => {
			return handleApiErrors(error);
		});
};
